export function encodeBase64<T>(object: T): string {
    return btoa(JSON.stringify(object));
}

export function decodeBase64<T>(base64: string): T {
    return JSON.parse(atob(base64)) as T;
}
